import React, { useState, useEffect } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import DownloadApp from '@/controller/downloadApp/downloadApp'
import 'antd/dist/antd.less'


// 页面rem适配
const changeSize = () => {
  // 如果是手机类型，直接return
  if (/(iPhone|iPad|iPod|iOS|Android|Windows Phone|BlackBerry|SymbianOS)/i.test(navigator.userAgent)) {
    var stdw = 750;
    var stdh = 1334;
    const baseSize = 100

    var docEl = document.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      recalc = function () {
        var clientWidth = docEl.clientWidth;
        var clientHeight = docEl.clientHeight;
        if (!clientWidth) return;
        const scale = Math.min(clientWidth / stdw, clientHeight / stdh)
        let size = (baseSize * Math.min(scale, 2)) < 20 ? 20 : (baseSize * Math.min(scale, 2))
        docEl.style.fontSize = size + 'px';

      };
    if (!document.addEventListener) return;
    recalc();
    window.addEventListener(resizeEvt, recalc, false);
    document.addEventListener('DOMContentLoaded', recalc, false);
    return
  }

  const baseSize = 100
  const scale = Math.min(
    document.documentElement.clientWidth / 2560,
    document.documentElement.clientHeight / 1440
  )
  let w = window.screen.width > 1920 ? 75 : 40
  let size = (baseSize * Math.min(scale, 4)) < w ? w : (baseSize * Math.min(scale, 4))
  document.documentElement.style.fontSize = size + 'px'
}



function App() {
  useEffect(() => {
    changeSize()  //页面rem适配
  }, []);

  return (
    <>
       <DownloadApp />
    </>
  );
}

export default App;
